import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from '@shared/ui';

interface DiscrepancyCommentDialogProps {
  open: boolean;
  loading?: boolean;
  text: string;
  reason: string;
  onOpenChange: (open: boolean) => void;
  onTextChange: (value: string) => void;
  onReasonChange: (value: string) => void;
  onConfirm: () => void;
}

export function DiscrepancyCommentDialog({
  open,
  loading = false,
  text,
  reason,
  onOpenChange,
  onTextChange,
  onReasonChange,
  onConfirm,
}: DiscrepancyCommentDialogProps) {
  const { t } = useTranslation('cabinet');
  const valid = text.trim().length >= 3 && reason.trim().length >= 3;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-h-[calc(100dvh-2rem)] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t('reconciliation.case.comment.title')}</DialogTitle>
          <DialogDescription>{t('reconciliation.case.comment.description')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="discrepancy-comment-text">{t('reconciliation.case.comment.text')}</Label>
            <Textarea
              id="discrepancy-comment-text"
              value={text}
              rows={4}
              onChange={(event) => onTextChange(event.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="discrepancy-comment-reason">{t('reconciliation.enqueue.reason')}</Label>
            <Textarea
              id="discrepancy-comment-reason"
              value={reason}
              rows={2}
              onChange={(event) => onReasonChange(event.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" className="w-full sm:w-auto" onClick={() => onOpenChange(false)}>
            {t('withdrawals.actions.back')}
          </Button>
          <Button type="button" className="w-full sm:w-auto" loading={loading} disabled={!valid} onClick={onConfirm}>
            {t('reconciliation.case.comment.action')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
